import { Link } from "react-router-dom";
import { Phone, Mail, MapPin, Facebook } from "lucide-react";

export const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-[#1F2937] text-white" data-testid="footer">
      <div className="max-w-7xl mx-auto px-4 md:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Company Info */}
          <div className="lg:col-span-2">
            <div className="flex items-center gap-3 mb-6">
              <img 
                src="https://customer-assets.emergentagent.com/job_guzman-landscaping/artifacts/yt963mfm_66C33DB7-9436-4D03-85ED-2BB500C30FDC.jpeg" 
                alt="J Guzman Landscaping Logo"
                className="h-16 w-auto"
              />
            </div>
            <p className="text-gray-400 mb-6 max-w-md leading-relaxed">
              Trusted landscaping company serving Joliet, IL and surrounding areas. 
              From lawn care to paver patios, retaining walls to snow removal — we transform outdoor spaces.
            </p>
            <div className="flex flex-col gap-3">
              <a
                href="tel:8159098790"
                className="flex items-center gap-3 text-gray-300 hover:text-white transition-colors"
                data-testid="footer-phone"
              >
                <Phone className="w-5 h-5 text-[#2F5930]" />
                <span>(815) 909-8790</span>
              </a>
              <a
                href="mailto:Jguzmanlandscaping01@gmail.com"
                className="flex items-center gap-3 text-gray-300 hover:text-white transition-colors"
                data-testid="footer-email"
              >
                <Mail className="w-5 h-5 text-[#2F5930]" />
                <span>Jguzmanlandscaping01@gmail.com</span>
              </a>
              <div className="flex items-center gap-3 text-gray-300">
                <MapPin className="w-5 h-5 text-[#2F5930]" />
                <span>Serving Joliet, IL and surrounding areas</span>
              </div>
              <a
                href="https://www.facebook.com/Jguzmanlandscaping"
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center gap-3 text-gray-300 hover:text-white transition-colors"
                data-testid="footer-facebook"
              >
                <Facebook className="w-5 h-5 text-[#2F5930]" />
                <span>Follow us on Facebook</span>
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-semibold text-lg mb-6 font-['Manrope']">Quick Links</h4>
            <nav className="flex flex-col gap-3">
              <Link to="/" className="footer-link">Home</Link>
              <Link to="/services" className="footer-link">Services</Link>
              <Link to="/service-areas" className="footer-link">Service Areas</Link>
              <Link to="/contact" className="footer-link">Contact</Link>
            </nav>
          </div>

          {/* Services */}
          <div>
            <h4 className="font-semibold text-lg mb-6 font-['Manrope']">Our Services</h4>
            <nav className="flex flex-col gap-3 text-gray-400">
              <span>Landscape Installation</span>
              <span>Paver Patios & Walkways</span>
              <span>Retaining Walls</span>
              <span>Concrete Services</span>
              <span>Snow Removal</span>
            </nav>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="mt-12 pt-8 border-t border-gray-700">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-gray-400 text-sm text-center md:text-left">
              &copy; {currentYear} J Guzman Landscaping LLC. All rights reserved.
            </p>
            <p className="text-gray-500 text-sm">
              Landscaping company serving Will County, IL
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};
